export enum RawspeedError {
	UnsupportedFormat,
	Corrupted,
	Unknown,
}

const ERROR_PATTERNS: Record<RawspeedError, string[]> = {
	[RawspeedError.UnsupportedFormat]: ["CameraMetadataException"],
	[RawspeedError.Corrupted]: ["RawDecoderException", "TiffParserException", "RawParserException"],
	[RawspeedError.Unknown]: [],
}

export function classifyRawError(error: unknown): RawspeedError {
	if (!(error instanceof WebAssembly.RuntimeError)) {
		return RawspeedError.Unknown
	}

	const message = error.message.toLowerCase()
	const errorType = Number(
		Object.entries(ERROR_PATTERNS).find(([_, patterns]) =>
			patterns.some((p) => message.includes(p.toLowerCase())),
		)?.[0],
	)

	return Number.isInteger(errorType) ? errorType : RawspeedError.Unknown
}
